import {
  KEYWORD_TRIGGERED_BANNER_ERROR,
  KEYWORD_TRIGGERED_BANNER_REQUESTED,
  KEYWORD_TRIGGERED_BANNER_SUCCESS,
} from "actions/const";
import config from "config";

function reducer(state = config.state.keywordTriggeredBanner, action) {
  switch (action.type) {
    case KEYWORD_TRIGGERED_BANNER_ERROR:
      return { ...state, markup: "", loading: false };

    case KEYWORD_TRIGGERED_BANNER_REQUESTED:
      return { ...state, markup: "", loading: true };

    case KEYWORD_TRIGGERED_BANNER_SUCCESS:
      const markup = action.markup ? { markup: action.markup } : { markup: "" };

      return { ...state, ...markup, loading: false };

    default:
      return state;
  }
}
export default reducer;
